import { UserAgent } from '../webcad/model';
import SVGMatrixParam from './SVGMatrixParam';

export default class Matrix3D {
  public n11: number;

  public n12: number;

  public n13: number;

  public n14: number;

  public n21: number;

  public n22: number;

  public n23: number;

  public n24: number;

  public n31: number;

  public n32: number;

  public n33: number;

  public n34: number;

  constructor(args: any = null) {
    if (!args) {
      this.n11 = 1; this.n12 = 0; this.n13 = 0; this.n14 = 0;
      this.n21 = 0; this.n22 = 1; this.n23 = 0; this.n24 = 0;
      this.n31 = 0; this.n32 = 0; this.n33 = 1; this.n34 = 0;
    } else if (args.length > 6) {
      // for CSS matrix3d
      [this.n11, this.n12, this.n13, this.n14, this.n21, this.n22, this.n23, this.n24, this.n31, this.n32, this.n33, this.n34] = args;
    } else {
      /*
      svgのmatrix座標系
      [
      a b e
      b d f
      0 0 1
      ]
      */
      // for SVG
      [this.n11, this.n12, this.n13, this.n21, this.n22, this.n23] = args;
      this.n14 = 0; this.n24 = 0;
      this.n31 = 0; this.n32 = 0; this.n33 = 1; this.n34 = 0;
    }
  }

  public reset(): void {
    this.n11 = 1; this.n12 = 0; this.n13 = 0; this.n14 = 0;
    this.n21 = 0; this.n22 = 1; this.n23 = 0; this.n24 = 0;
    this.n31 = 0; this.n32 = 0; this.n33 = 1; this.n34 = 0;
  }

  public multiply(m: Matrix3D): void {
    const d11 = this.n11;
    const d12 = this.n12;
    const d13 = this.n13;
    const d14 = this.n14;
    const d21 = this.n21;
    const d22 = this.n22;
    const d23 = this.n23;
    const d24 = this.n24;
    const d31 = this.n31;
    const d32 = this.n32;
    const d33 = this.n33;
    const d34 = this.n34;

    this.n11 = d11 * m.n11 + d12 * m.n21 + d13 * m.n31;
    this.n12 = d11 * m.n12 + d12 * m.n22 + d13 * m.n32;
    this.n13 = d11 * m.n13 + d12 * m.n23 + d13 * m.n33;
    this.n14 = d11 * m.n14 + d12 * m.n24 + d13 * m.n34 + d14;

    this.n21 = d21 * m.n11 + d22 * m.n21 + d23 * m.n31;
    this.n22 = d21 * m.n12 + d22 * m.n22 + d23 * m.n32;
    this.n23 = d21 * m.n13 + d22 * m.n23 + d23 * m.n33;
    this.n24 = d21 * m.n14 + d22 * m.n24 + d23 * m.n34 + d24;

    this.n31 = d31 * m.n11 + d32 * m.n21 + d33 * m.n31;
    this.n32 = d31 * m.n12 + d32 * m.n22 + d33 * m.n32;
    this.n33 = d31 * m.n13 + d32 * m.n23 + d33 * m.n33;
    this.n34 = d31 * m.n14 + d32 * m.n24 + d33 * m.n34 + d34;
  }

  public copy(): Matrix3D {
    return new Matrix3D([this.n11, this.n12, this.n13, this.n14, this.n21, this.n22, this.n23, this.n24, this.n31, this.n32, this.n33, this.n34]);
  }

  public toString(): string {
    return `n11=${this.n11}, n12=${this.n12}, n13=${this.n13}, n14=${this.n14}, n21=${this.n21}, n22=${this.n22}, n23=${this.n23}, n24=${this.n24}, n31=${this.n31}, n32=${this.n32}, n33=${this.n33}, n34=${this.n34}`;
    // return "n11=" + this.n11 + ", n12=" + this.n12 + ", n13=" + this.n13 + ", n14=" + this.n14 + ", n21=" + this.n21 + ", n22=" + this.n22 + ", n23=" + this.n23 + ", n24=" + this.n24 + ", n31=" + this.n31 + ", n32=" + this.n32 + ", n33=" + this.n33 + ", n34=" + this.n34;
  }

  public cssMatrix3D(): string {
    const enc: Function = (val: number): number => Math.round(val * 10000) / 10000;

    const str: string = `matrix3d(${enc(this.n11)},${enc(this.n12)},${enc(this.n13)}, 0, ${enc(this.n21)}, ${enc(this.n22)}, ${enc(this.n23)}, 0, ${enc(this.n31)}, ${enc(this.n32)}, ${enc(this.n33)}, 0, ${this.n14}, ${this.n24}, ${enc(this.n34)}, 1)`;

    // let str: string = "matrix3d(";
    // str += enc(this.n11) + ", " + enc(this.n12) + ", " + enc(this.n13) + ", 0, ";
    // str += enc(this.n21) + ", " + enc(this.n22) + ", " + enc(this.n23) + ", 0, ";
    // str += enc(this.n31) + ", " + enc(this.n32) + ", " + enc(this.n33) + ", 0, ";
    // str += this.n14 + ", " + this.n24 + ", " + enc(this.n34) + ", 1)";

    return str;
  }

  public svgMatrix(): string {
    const enc: Function = (val: number): number => Math.round(val * 10000) / 10000;

    const str: string = `matrix(${enc(this.n11)}, ${enc(this.n21)}, ${enc(this.n12)}, ${enc(this.n22)}, ${enc(this.n13)}, ${enc(this.n23)})`;
    // var str: string = "matrix(";
    // str += enc(this.n11) + ", " + enc(this.n21) + ", ";
    // str += enc(this.n12) + ", " + enc(this.n22) + ", ";
    // str += enc(this.n13) + ", " + enc(this.n23) + ")";

    return str;
  }

  /*
   * svgのmatrix文字列からx/y/scaleX/scaleYを取り出す
   */
  public static convertMatrixString(str: string): SVGMatrixParam {
    const obj: SVGMatrixParam = new SVGMatrixParam();

    if (str !== '' && str != null) {
      let newStr: string = str;
      newStr = newStr.replace('matrix(', '');
      newStr = newStr.replace(')', '');

      const values: string[] = newStr.split((UserAgent.isIE ? ' ' : ','));

      obj.scaleX = parseFloat(values[0]);
      obj.scaleY = parseFloat(values[3]);
      obj.x = parseFloat(values[4]);
      obj.y = parseFloat(values[5]);
      // "matrix( 1, 0, 0, 1, -30,0) "
    } else {
      obj.x = 0;
      obj.y = 0;
      obj.scaleX = 1;
      obj.scaleY = 1;
    }

    return obj;
  }
}
